import axios from 'axios'
import ReactGA from 'react-ga4'
import { LOCATION_CHANGE } from 'react-router-redux'
import { call, fork, put, select, take } from 'redux-saga/effects'
import { SET_CURRENT_USER } from '../actions/authActions'
import { CustomPcStore } from '../store'

export function* runLocationChangeHandler() {
  while (true) {
    yield take([`${LOCATION_CHANGE}`])
    yield fork(locationChangeHandler)
  }
}
function* locationChangeHandler() {
  const auth = yield select<CustomPcStore>(state => state.auth)

  if (auth.currentUserId) {
    return
  }

  try {
    const { data } = yield call(getCurrentUserProfile)
    const userId = data.data.id
    ReactGA.set({ userId: `DB_MEMBER_${userId}` })
    yield put(SET_CURRENT_USER({ userId }))
  } catch (error) {
    // エラーは握りつぶす
  }
}

const getCurrentUserProfile = () => {
  return axios.get('/api/v1/organizers/profile')
}
